<template>
  <div class="flex flex-col glass-frosted rounded-8xl p-4 relative box-border h-27">
    <div class="flex items-center text-l-medium text-black-white">
      <Icon icon="LightEffect-Wireframe-Speed" class="size-6 mr-1" />
      {{ $t('lighting.lightingSpeed') }}
    </div>
    <div class="flex items-center w-full mt-4">
      <Icon icon="LightEffect-Wireframe-LightSlow" class="size-4 text-black-white" />
      <div
        ref="sliderRef"
        class="w-full flex-1 h-4 bg-glass30 rounded-8xl cursor-pointer relative mx-1"
        @mousedown="startDrag"
      >
        <div
          class="bg-white h-full rounded-8xl relative overflow-hidden"
          :style="{
            width: `${modelValue}%`,
          }"
        >
          <div
            class="absolute top-1/2 right-1 -translate-y-1/2 w-1 h-1 rounded-full bg-black/10"
          ></div>
        </div>
        <div
          class="absolute top-full z-tooltip -translate-x-1/2 rounded-md bg-primary px-2 py-1 text-s-medium text-black-white tabular-nums whitespace-nowrap pointer-events-none select-none"
          :style="{ left: `calc(${modelValue}% - 4px)` }"
        >
          {{ modelValue }}%
        </div>
      </div>
      <Icon icon="LightEffect-Wireframe-LightFast" class="size-4 text-black-white" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import { Icon } from '@rapoo/element'
  import { useSliderDrag } from '@/composables/useSliderDrag'

  const props = withDefaults(defineProps<{ modelValue: number }>(), {
    modelValue: 60,
  })
  const emit = defineEmits(['update:modelValue', 'change'])

  const sliderRef = ref<HTMLElement | null>(null)
  const { startDrag } = useSliderDrag(sliderRef, {
    onChange(percentage) {
      emit('update:modelValue', Math.round(percentage))
    },
    onEnd(percentage) {
      emit('change', Math.round(percentage))
    },
  })
</script>
